import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginFormComponent {
  @Input() email = '';
  @Input() password = '';
  @Input() rememberMe = false;
  @Input() showPassword = false;
  @Input() isLoading = false;
  @Input() errorMessage = '';
  @Input() showForgotPassword = false;
  @Input() resetMessage = '';
  @Input() hasResetError = false;
  @Input() showProductLogo = false;
  @Input() productLogoUrl = '';
  /** Hides the welcome eyebrow, title, and intro when the shell provides its own header. */
  @Input() hideWelcomeHeader = false;
  @Input() formEyebrow = 'WELCOME TO ASCENT';
  @Input() formHeading = 'Sign in to Ascent.';
  @Input() formIntro = 'Your training, records and next steps. All in one place.';

  @Output() emailChange = new EventEmitter<string>();
  @Output() passwordChange = new EventEmitter<string>();
  @Output() rememberMeChange = new EventEmitter<boolean>();
  @Output() submitForm = new EventEmitter<void>();
  @Output() forgotPassword = new EventEmitter<void>();
  @Output() resetPassword = new EventEmitter<void>();
  @Output() togglePassword = new EventEmitter<void>();
  @Output() backToSignIn = new EventEmitter<void>();
  @Output() supportClick = new EventEmitter<void>();
  @Output() privacyClick = new EventEmitter<void>();
  @Output() termsClick = new EventEmitter<void>();

  canSignIn(): boolean {
    return this.email.trim().length > 0 && this.password.trim().length > 0 && !this.isLoading;
  }

  canResetPassword(): boolean {
    return this.email.trim().length > 0 && !this.isLoading;
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    if (this.showForgotPassword) {
      this.resetPassword.emit();
      return;
    }
    if (this.canSignIn()) {
      this.submitForm.emit();
    }
  }

  onEmailInput(value: string): void {
    this.emailChange.emit(value);
  }

  onPasswordInput(value: string): void {
    this.passwordChange.emit(value);
  }

  onRememberChange(checked: boolean): void {
    this.rememberMeChange.emit(checked);
  }
}
